<template>
  <div class="max-w-5xl">
    <form class="cookie-settings__form">
      <div class="overflow-y-scroll max-h-[75vh] p-8 pb-0" style="border-bottom: 1px solid #e1e7ea">
        <h2 class="text-h35 mb-4">
          {{ $t("headline") }}
        </h2>
        <p class="cookie-settings__copy">
          {{ $t("copy") }}
          <a :href="$options.privacyPath" class="cookie-settings__privacy text-dark-grey underline">
            <span>{{ $t("privacy") }}</span> </a
          >.
        </p>
        <div class="cookie-settings__fields">
          <cookie-field class="cookie-settings__field" name="necessary" :disabled="true" v-model="necessary" />
          <cookie-field class="cookie-settings__field" name="statistics" v-model="statistics" />
          <cookie-field class="cookie-settings__field" name="preferences" v-model="preferences" />
          <cookie-field class="cookie-settings__field" name="marketing" v-model="marketing" />
        </div>
      </div>
      <div class="cookie-settings__actions flex-row-reverse justify-around mx-auto max-w-[400px] px-2 py-4">
        <button
          @click.prevent="onSubmit"
          type="button"
          class="w-fit cookie-settings__cta js-pw-link rounded p-2 m:px-4 button--midnight mb-0"
          data-event-category="popup-20200728-cookie_settings_submit"
          data-event-depth="1"
          data-event-action="click"
        >
          <span>{{ $t("saveSelection") }}</span>
        </button>
        <button
          type="button"
          class="cookie-settings__consent-all js-pw-link"
          data-modal-open-step="cookie-banner:settings"
          @click="consentAllCookies"
          data-event-category="popup-20200728-cookie_settings_all"
          data-event-depth="1"
          data-event-action="click"
        >
          <span>{{ $t("allowAllCookies") }}</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex"
import CookieField from "./cookie-field"
import globals from "@/utils/globals"

export default {
  name: "CookieSettings",
  components: {
    CookieField
  },
  privacyPath: globals.routes.privacyCookiebot,
  data() {
    return {
      necessary: true,
      statistics: false,
      preferences: false,
      marketing: false
    }
  },
  computed: {
    ...mapState({
      options: (state) => state.user.cookies.options
    })
  },
  watch: {
    options: {
      handler(v) {
        this.necessary = v.necessary
        this.statistics = v.statistics
        this.preferences = v.preferences
        this.marketing = v.marketing
      },
      immediate: true
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Choose your cookie settings",
        copy: "This tool enables you to activate or deactivate cookies, trackers and other technologies used on our website. You can navigate between the different groups of technologies and find detailed information about each group. You have the option to turn each of the categories on or off individually. You can change your preferences at any time with future effect by visiting this tool via our Cookie Policy, or via the link in the website footer. You can find more information about the third parties Blinkist might share your data with in our",
        privacy: "Cookie Policy",
        saveSelection: "Save selection",
        allowAllCookies: "Allow all cookies"
      },
      de: {
        headline: "Wähle deine Cookie-Einstellungen!",
        copy: "Mit diesem Tool kannst du Cookies, Tracker und andere Technologien, die auf unserer Website verwendet werden, aktivieren oder deaktivieren. Du kannst zwischen den verschiedenen Technologiekategorien navigieren und detaillierte Informationen zu jeder Kategorie finden. Du kannst jede Kategorie einzeln aktivieren oder deaktivieren. Du kannst deine Einstellungen jederzeit mit Wirkung für die Zukunft ändern, indem du dieses Tool über unsere Cookie-Richtlinie oder über den Link in der Fußzeile der Website aufrufst. Weitere Informationen zu Drittanbietern, mit denen Blinkist deine Informationen teilen kann, findest du in unserer",
        privacy: "Cookie-Richtlinie",
        saveSelection: "Auswahl speichern",
        allowAllCookies: "Alle Cookies akzeptieren"
      },
      es: {
        headline: "Elije tu configuración de cookies",
        copy: "Esta herramienta te permite activar o desactivar cookies, rastreadores y otras tecnologías utilizadas en nuestro sitio web. Puedes navegar entre los diferentes grupos de tecnologías y encontrar información detallada sobre cada grupo. Tienes la opción de activar o desactivar cada una de las categorías individualmente. Puedes cambiar tus preferencias en cualquier momento con efecto futuro visitando esta herramienta a través de nuestra Política de cookies, o a través del enlace en el pie de página del sitio web. Puedes encontrar más información sobre los terceros con los que Blinkist podría compartir tus datos en nuestra",
        privacy: "Política de Cookies",
        saveSelection: "Guardar selección",
        allowAllCookies: "Permitir todas las cookies"
      }
    }
  },
  methods: {
    consentAllCookies() {
      this.$emit("consent-all")
    },
    onSubmit() {
      this.$emit("consent", {
        statistics: this.statistics,
        preferences: this.preferences,
        marketing: this.marketing
      })
    }
  }
}
</script>

<style lang="scss">
.cookie-settings {
  @include font-family(sans-serif);

  &__copy {
    @include font-style(p);

    margin-bottom: $spacing-16;
  }

  &__privacy {
    display: inline-block;
  }

  &__fields {
    margin-bottom: $spacing-24;
    padding-top: $spacing-16;
  }

  &__field {
    &:not(:last-child) {
      margin-bottom: $spacing-16;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__cta {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: $spacing-16;

    font-family: inherit;

    cursor: pointer;

    span {
      max-width: $wide-block-width;
    }
  }

  &__consent-all {
    @include font-style(button, $color: $mid-grey);

    font-family: inherit;

    cursor: pointer;

    &:hover {
      color: $midnight;
    }
  }

  @include media(min-width, m) {
    padding: $spacing-24 $spacing-24;
  }
}
</style>
